<template>
  <div class="export-history d-flex flex-column flex-grow-1" data-test="exportHistory">
    <h3>{{ $t('exam.exportHistoryTitle') }}</h3>
    <div class="scrollbar flex-grow-1 overflow-auto pe-2">
      <div v-if="loading" class="text-center">
        <span class="spinner-border spinner-border-sm"></span>
      </div>
      <p v-else-if="!history.length" class="export-history-empty">{{ $t('exam.exportHistoryEmpty') }}</p>
      <template v-else>
        <div v-for="item in history" :key="item.number" class="export-history-entry">
          <div class="export-history-item d-flex flex-column gap-1" data-test="exportHistoryItem">
            <div class="d-flex justify-content-between align-items-center">
              <strong>{{ $t('exam.exportHistoryId') }} #{{ item.number }}</strong>
              <span class="label" :class="statusClass(item.status)">{{ statusLabel(item.status) }}</span>
            </div>
            <small>{{ $t('exam.exportHistoryRequestedAt') }}: {{ formatDate(item.createdAt) }}</small>
            <small v-if="isFinished(item.status)">{{ $t('exam.exportHistoryFinishedAt') }}: {{ formatDate(item.updatedAt) }}</small>
            <small v-if="item.agent">{{ $t('exam.exportHistoryRequestedBy') }}: {{ item.agent }}</small>
          </div>
          <hr/>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.export-history {
  min-height:                       160px;
  color:                            var(--Brand-Primary, #1B294A);

  h3 {
    color:                          var(--Brand-Primary, #1B294A);
    font-size:                      var(--font-size-18);
    font-weight:                    300;
    line-height:                    normal;
    margin:                         16px 0 10px;
  }

  .export-history-empty {
    font-size:                      var(--font-size-14);
    font-weight:                    300;
    margin:                         0;
  }

  .export-history-item small {
    color:                          var(--Shades-50);
    font-size:                      var(--font-size-12);
  }

  // the separator only goes between the items: the last one has none
  .export-history-entry:last-child hr {
    display:                        none;
  }
}
</style>

<script>
// ClinicBatch status -> i18n key under exam.exportStatus
const STATUS_I18N = {
  'started': 'started',
  'exporting': 'exporting',
  'completed': 'completed',
  'fail-start': 'failStart',
  'fail-export': 'failExport',
  'fail-reset': 'failReset'
}
const IN_PROGRESS = ['started', 'exporting']

export default {
  name: 'BaseExportHistory',
  props: {
    // Type of the batches listed: 'backup', 'report'...
    batchType: { type: String, required: true }
  },
  data: () => ({
    history: [],
    loading: false
  }),
  methods: {
    // Called by the parent every time its offcanvas opens.
    async fetchHistory() {
      this.loading = true

      try {
        const response = await this.$clinicService.getExportHistory({ batchType: this.batchType })
        this.history = response.result || []
      } catch (err) {
        this.history = []
      } finally {
        this.loading = false
      }
    },

    statusLabel(status) {
      const key = STATUS_I18N[status]
      return key ? this.$t(`exam.exportStatus.${key}`) : status
    },

    statusClass(status) {
      if (status === 'completed') return 'label-success'
      if (IN_PROGRESS.includes(status)) return 'label-warning'
      return 'label-danger'
    },

    isFinished(status) {
      return !IN_PROGRESS.includes(status)
    },

    formatDate(value) {
      return moment(value).format(this.$i18n.t('dateTimeFormat'))
    }
  }
}
</script>
